export const satoshiCoefficient = 100000000;